/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionDataAggregatedSubmissions } from '../../models/submission-data-aggregated-submissions';
import { SubmissionDataAggregationInput } from '../../models/submission-data-aggregation-input';

export interface AggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Params {
  org: string;
  recipients?: (Array<string> | null);

/**
 * If set to True, only completed submissions will be considered.
 */
  showCompletedOnly?: boolean;
      body: SubmissionDataAggregationInput
}

export function aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost(http: HttpClient, rootUrl: string, params: AggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionDataAggregatedSubmissions>> {
  const rb = new RequestBuilder(rootUrl, aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost.PATH, 'post');
  if (params) {
    rb.path('org', params.org, {});
    rb.query('recipients', params.recipients, {});
    rb.query('showCompletedOnly', params.showCompletedOnly, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionDataAggregatedSubmissions>;
    })
  );
}

aggregateSubmissionsApiV2SubmissionsOrgSubmissionsDataOverviewPost.PATH = '/api/v2/submissions/{org}/submissions/data/overview';
